import { prefix } from './_common'

export const ROUTE_ADMIN_USERS = prefix.admin('users')

export const ROUTE_ADMIN_SERVERS = prefix.admin('servers')
